<div v-if="is_open" class="settings-modal-backdrop" @click.self="close_modal">
    <div v-if="visible_form_error" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ visible_form_error }}</div>
                <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_form_error"></button>
            </div>
        </div>
    </div>

    <div class="settings-modal-card glass-card rounded-4 settings-assignment-modal-card p-0">
        <div class="p-3 border-bottom border-white border-opacity-10">
            <h4 class="text-white fw-bold text-sm mb-0">Assign Tariff to Property</h4>
        </div>

        <form @submit.prevent="submit_form">
            <div class="p-3">
                <div class="row g-3">
                    <div class="col-md-6">
                        <label class="form-label text-white text-xs fw-semibold mb-1">Property name</label>
                        <input
                            v-if="is_property_locked"
                            :value="selected_property?.name || 'Selected property'"
                            type="text"
                            class="form-control form-control-sm bg-dark text-white border-secondary rounded-3 text-xs"
                            disabled
                        />
                        <select
                            v-else
                            ref="property_select"
                            :value="tariff_form.property_id"
                            :class="['form-select form-select-sm bg-dark text-white rounded-3 text-xs', field_errors.property_id ? 'border-danger' : 'border-secondary']"
                            required
                            @change="update_form_field('property_id', $event.target.value)"
                        >
                            <option value="" disabled>
                                {{ active_properties.length ? "Select property" : "No active properties available" }}
                            </option>
                            <option v-for="property in active_properties" :key="property.id" :value="property.id">
                                {{ property.name }}
                            </option>
                        </select>
                        <div v-if="field_errors.property_id" class="invalid-feedback d-block text-xs">
                            {{ field_errors.property_id }}
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label text-white text-xs fw-semibold mb-1">Municipality</label>
                        <input
                            :value="tariff_form.municipality_search"
                            list="settings-municipality-options"
                            type="text"
                            class="form-control form-control-sm bg-dark text-white border-secondary rounded-3 text-xs"
                            placeholder="Search municipality"
                            @input="update_municipality_input($event.target.value)"
                        />
                        <datalist id="settings-municipality-options">
                            <option v-for="municipality in municipality_options" :key="municipality.id" :value="municipality.name"></option>
                        </datalist>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label text-white text-xs fw-semibold mb-1">Tariff book</label>
                        <select
                            ref="tariff_book_select"
                            :value="tariff_form.tariff_book_id"
                            :class="['form-select form-select-sm bg-dark text-white rounded-3 text-xs', field_errors.tariff_book_id ? 'border-danger' : 'border-secondary']"
                            required
                            @change="update_form_field('tariff_book_id', $event.target.value)"
                        >
                            <option value="" disabled>
                                {{ filtered_tariff_books.length ? "Select tariff book" : "No tariff books available" }}
                            </option>
                            <option v-for="tariff_book in filtered_tariff_books" :key="tariff_book.id" :value="tariff_book.id">
                                {{ tariff_book.name }} - {{ tariff_book.tariff_category }}
                            </option>
                        </select>
                        <div v-if="field_errors.tariff_book_id" class="invalid-feedback d-block text-xs">
                            {{ field_errors.tariff_book_id }}
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label text-white text-xs fw-semibold mb-1">Tariff</label>
                        <select
                            ref="tariff_select"
                            :value="tariff_form.tariff_id"
                            :class="['form-select form-select-sm bg-dark text-white rounded-3 text-xs', field_errors.tariff_id ? 'border-danger' : 'border-secondary']"
                            :disabled="!tariff_form.tariff_book_id"
                            @change="update_form_field('tariff_id', $event.target.value)"
                        >
                            <option value="" disabled>
                                {{ tariff_form.tariff_book_id ? "Select tariff" : "Select tariff book first" }}
                            </option>
                            <option v-for="tariff in filtered_tariffs" :key="tariff.id" :value="tariff.id">
                                {{ tariff.name }}
                            </option>
                        </select>
                        <div v-if="field_errors.tariff_id" class="invalid-feedback d-block text-xs">
                            {{ field_errors.tariff_id }}
                        </div>
                    </div>

                    <div class="col-12">
                        <label class="form-label text-white text-xs fw-semibold d-block mb-1">Status</label>
                        <div class="form-check form-switch d-inline-flex align-items-center gap-2 ps-0">
                            <input
                                id="settings-is-active"
                                :checked="Boolean(tariff_form.is_active)"
                                class="form-check-input ms-0"
                                type="checkbox"
                                role="switch"
                                @change="update_form_field('is_active', $event.target.checked)"
                            />
                            <label for="settings-is-active" class="form-check-label text-white text-xs fw-semibold">
                                {{ tariff_form.is_active ? "Active" : "Inactive" }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end align-items-center gap-2 p-3 border-top border-white border-opacity-10">
                <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn button-outline btn-outline-light rounded-3 d-flex align-items-center gap-1 settings-button-shape" @click="close_modal">
                        <span class="text-xs">Cancel</span>
                    </button>
                    <button type="submit" class="btn-primary rounded-3 d-flex align-items-center gap-1 settings-button-shape" :disabled="is_saving">
                        <span class="text-xs">{{ submit_button_label }}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
